import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { seoArticlePages } from "../seoPages";
import "./SEOArticlePage.css";

function SEOArticlePage() {
  const { slug } = useParams();

  const page = seoArticlePages.find((item) => item.slug === `/${slug}`);

  if (!page) {
    return <Navigate to="/career-guides" replace />;
  }

  return (
    <main className="seo-article-page">
      <SEOHead
        title={page.metaTitle.replace(" | EmployPilot", "")}
        description={page.metaDescription}
        canonical={`https://employpilot.com${page.slug}`}
      />

      <article className="seo-article-container">
        <p className="seo-article-category">{page.category}</p>

        <h1>{page.h1}</h1>

        <p className="seo-article-intro">{page.intro}</p>

        {page.sections.map((section, index) => (
          <section key={index} className="seo-article-section">
            <h2>{section.heading}</h2>

            {section.paragraphs.map((paragraph, paragraphIndex) => (
              <p key={paragraphIndex}>{paragraph}</p>
            ))}

            {section.bullets && (
              <ul>
                {section.bullets.map((bullet, bulletIndex) => (
                  <li key={bulletIndex}>{bullet}</li>
                ))}
              </ul>
            )}

            {section.example && (
              <div className="seo-example-box">
                <strong>Example:</strong>
                <p>{section.example}</p>
              </div>
            )}
          </section>
        ))}

        {page.checklist && (
          <section className="seo-article-section">
            <h2>{page.checklist.heading}</h2>
            <ul>
              {page.checklist.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>
        )}

        <section className="seo-article-section seo-soft-cta">
          <h2>{page.softCta.heading}</h2>
          {page.softCta.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </section>

        {page.faqs && (
          <section className="seo-article-section">
            <h2>Frequently Asked Questions</h2>
            {page.faqs.map((faq, index) => (
              <div key={index} className="seo-faq-item">
                <h3>{faq.question}</h3>
                <p>{faq.answer}</p>
              </div>
            ))}
          </section>
        )}

        {page.internalLinks && (
          <section className="seo-related-links">
            <h2>Related EmployPilot Resources</h2>
            <div className="seo-related-grid">
              {page.internalLinks.map((link, index) => (
                <Link key={index} to={link.href}>
                  {link.label}
                </Link>
              ))}
            </div>
          </section>
        )}
      </article>
    </main>
  );
}

export default SEOArticlePage;